<template>
  <div class="page">
    <div class="page-container">
      <div class="page-title">会议投票</div>
      <div class="w1200 v-px-md">
        <div class="panel-info-section">
          <div class="panel-info-section-title">
            <a-icon type="caret-right" class="text-primary v-mr-xs" />
            <span class="text-bold">会议基本信息</span>
          </div>
          <table class="table table-plain">
            <tbody>
              <tr>
                <th width="180">会议名称</th>
                <td>{{ record.meetingTitle }}</td>
              </tr>
              <tr>
                <th>会议评审时间</th>
                <td>
                  {{ record.meetingStartTime }} <template v-if="record.meetingStartTime">~ {{ record.meetingEndTime }}</template>
                </td>
              </tr>
              <tr>
                <th>会议方式</th>
                <td>{{ record.meetingType }}</td>
              </tr>

              <tr>
                <th>美丽心灵参会人员</th>
                <td>{{ record.otherParticipant }}</td>
              </tr>
              <tr>
                <th>专家参会清单</th>
                <td><a-tag color="red" v-for="item in record.experts" :key="item.userName">{{ item.realName }}</a-tag></td>
              </tr>
              <tr>
                <th>会议备注</th>
                <td>{{ record.meetingRemark }}</td>
              </tr>
              <tr>
                <th>会议文件</th>
                <td>
                  <file-container :files="record.files" :belongId="meetingId" fileSign="PM" v-if="meetingId"></file-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="panel-info-section">
          <div class="panel-info-section-title">
            <a-icon type="caret-right" class="text-primary v-mr-xs" />
            <span class="text-bold">会议投票主题</span>
          </div>
          <div class="vote-list" style="background: #f8f9fc; padding: 8px 12px" :class="{ 'v-mt-md': index > 0 }" v-for="(item, index) in record.votes" :key="index">
            <div class="vote-title">
              <span class="text-bold">{{ index + 1 }}、{{ item.title }}</span
              ><span v-if="item.voteType === 1">（最多选择{{ item.maxNum }}项）</span>
            </div>
            <div class="vote-desc v-mb-sm text-grey v-mt-xs" v-if="item.description">{{ item.description }}</div>
            <div>
              <template v-if="item.voteType === 0">
                <a-radio-group v-model="voteCheckOptions[index].checkOption" name="radioGroup">
                  <a-radio :value="option.optionId" v-for="option in item.options" :key="option.optionId">{{ option.content }}</a-radio>
                </a-radio-group>
              </template>
              <template v-else-if="item.voteType === 1">
                <a-checkbox-group v-model="voteCheckOptions[index].checkOption">
                  <a-checkbox :value="option.optionId" v-for="option in item.options" :key="option.optionId">{{ option.content }}</a-checkbox>
                </a-checkbox-group>
              </template>
            </div>
            <a-textarea class="v-mt-sm" placeholder="投票意见" v-model="voteCheckOptions[index].opinion" :autosize="{ minRows: 3, maxRows: 6}" style="max-width: 600px"></a-textarea>
          </div>
        </div>
      </div>
      <div class="text-center v-my-lg">
        <a-space>
          <a-button icon="check" type="primary" @click="onSubmitVote" v-if="record.meetingState === 1">提交投票</a-button>
          <a-button icon="left" type="default" @click="$router.go(-1)">返回</a-button>
        </a-space>
      </div>
    </div>
  </div>
</template>

<script>
import { getMeeting, submitVote } from '@/api/project/meeting'

export default {
  name: 'vote',
  data() {
    return {
      record: {},
      loading: false,
      meetingId: +this.$route.query.id,
      voteCheckOptions: [],
      voteCheckResults: [],
    }
  },
  methods: {
    init() {
      let { id, pid } = this.$route.query
      if (id) {
        this.meetingId = +id
        this.load()
      }
      if (pid) {
        this.projectId = +pid
      }
    },
    load() {
      this.loading = true
      getMeeting(this.meetingId)
        .then(({ data }) => {
          if (data.success) {
            this.record = data.result
            let votes = this.record.votes
            votes.forEach(vote => {
              vote.opinion = ''
              let voteCheckOption = {}
              voteCheckOption.voteId = vote.voteId
              voteCheckOption.voteType = vote.voteType
              voteCheckOption.maxNum = vote.maxNum
              voteCheckOption.title = vote.title
              voteCheckOption.opinion = ''
              if (vote.voteType == 0) {
                voteCheckOption.checkOption = vote.options[0].optionId
                this.voteCheckOptions.push(voteCheckOption)
              } else {
                voteCheckOption.checkOption = []
                this.voteCheckOptions.push(voteCheckOption)
              }
            })
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    onSubmitVote() {
      this.$message.destroy()
      let breakFlag = false
      let results = []
      this.voteCheckOptions.forEach((item, index) => {
        if (breakFlag) {
          return false
        }
        if (item.voteType == 0) {
          let voteCheckResult = {}
          voteCheckResult.voteId = item.voteId
          voteCheckResult.chooseOptionId = item.checkOption
          voteCheckResult.opinion = item.opinion
          results.push(voteCheckResult)
        } else {
          if (item.checkOption.length > 0) {
            if (item.checkOption.length > item.maxNum) {
              breakFlag = true
              this.$message.warn(`【${item.title}】最多选择${item.maxNum}项`)
            } else {
              item.checkOption.forEach(optionResult => {
                let voteCheckResult = {}
                voteCheckResult.voteId = item.voteId
                voteCheckResult.chooseOptionId = optionResult
                voteCheckResult.opinion = item.opinion
                results.push(voteCheckResult)
              })
            }
          } else {
            this.$message.warn(`【${item.title}】请至少选择一个选项`)
            breakFlag = true
          }
        }
      })
      if (breakFlag) {
        return
      }
      let params = {
        meetingId: this.meetingId,
        results
      }
      console.log(params)
      this.$confirm({
        title: `确认投票？`,
        onOk: () => {
          return new Promise((resolve, reject) => {
            submitVote(params).then(({ data }) => {
              if (data.success) {
                this.$message.success('投票成功')
                this.$router.go(-1)
                resolve()
              } else {
                this.$message.warn('操作失败')
                reject()
              }
            }).catch(() => {
              this.$message.warn('服务器响应错误')
              reject()
            })
          })
        },
      })
      
    },
  },
  created() {
    this.load()
  },
}
</script>
